var Handlebars = require('/home/circleci/project/node_modules/handlebars/lib/index.js');
module.exports = (Handlebars['default'] || Handlebars).template({"1":function(depth0,helpers,partials,data) {
  return "Information From LinkedIn Profile (<a\n        class=\"js-clear-information\">Clear</a>)";
  },"3":function(depth0,helpers,partials,data) {
  var stack1, buffer = "\n";
  stack1 = this.invokePartial(partials.linkedinInfo, '    ', 'linkedinInfo', depth0, undefined, helpers, partials, data);
  if (stack1 != null) { buffer += stack1; }
  return buffer + "\n";
},"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
  var stack1, buffer = "<p class=\"standard-form-label\">";
  stack1 = helpers['if'].call(depth0, (depth0 != null ? depth0.hasLinkedinInformation : depth0), {"name":"if","hash":{},"fn":this.program(1, data),"inverse":this.noop,"data":data});
  if (stack1 != null) { buffer += stack1; }
  buffer += "</p>\n\n";
  stack1 = helpers['if'].call(depth0, (depth0 != null ? depth0.hasLinkedinInformation : depth0), {"name":"if","hash":{},"fn":this.program(3, data),"inverse":this.noop,"data":data});
  if (stack1 != null) { buffer += stack1; }
  return buffer;
},"usePartial":true,"useData":true});